export default __webpack_public_path__ + "static/media/kredy-text.b0724a68.svg";